import axios from "axios";

const api = axios.create({
    // baseURL: "http://localhost/API/",
    baseURL: "https://protocolo.api.sif.org.br/",
});

export default api;
